import React, { Component } from 'react';

import { AgGridReact } from "@ag-grid-community/react";
import { Loader } from 'semantic-ui-react';
import { ACTION_STATUS } from '../../../../../utils/ActionStatus';
import '../../ApprovalRequest.css';

class BannedTradeRequestGrid extends Component {

  constructor(props) {
    super(props);

    this.state = {
      columnDefs: props.bannedTradeRequestGridColumns,
      defaultColDef: {
        enableCellChangeFlash: true,
        minWidth: 100
      },
      rowSelection: "multiple",
    };
  }

  onSelectionChanged = (event) => {
    var rowNodeArray = event.api.getSelectedNodes();
    var bannedTradeRequestList = rowNodeArray.map(rowNode => rowNode.data);

    this.props.selectBannedTradeRequest(bannedTradeRequestList);
  }

  getRowNodeId = data => {
    return data.requestId;
  };

  onGridReady = params => {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;

    // const COLUMNS_KEY = 'fund-list-grid-col-state';

    // StateSynchronizer.syncGrid(
    //   params,
    //   this.state.columnDefs,
    //   () => localStorageClient.getGridColumnState(COLUMNS_KEY),
    //   s => localStorageClient.saveGridColumnState(COLUMNS_KEY, s)
    // );
  };

  render() {
    const {
      bannedTradeRequestArray,
      className = 'grid-wrapper',
      loadBannedTradeRequestActionStatus,
    } = this.props;

    const isLoading = loadBannedTradeRequestActionStatus === ACTION_STATUS.LOGINING;
    if (loadBannedTradeRequestActionStatus === ACTION_STATUS.SUCCESS) {
      this.props.initLoadBannedTradeRequestActionStatus();
    }

    return (
      <div className={`ag-theme-balham ${className}`}>
        {isLoading ? (
            <Loader active content="Loading..." />
          ) : (
          <AgGridReact
            // properties
            columnDefs={this.state.columnDefs}
            rowData={bannedTradeRequestArray}
            defaultColDef={this.state.defaultColDef}
            rowSelection={this.state.rowSelection}
            enableSorting={true}
            enableFilter={true}
            animateRows={true}
            deltaRowDataMode={false}
            enableColResize={true}
            getRowNodeId={this.getRowNodeId}
            // events
            onGridReady={this.onGridReady}
            onSelectionChanged={this.onSelectionChanged}
          />
        )}
      </div>
    );
  }
}

export default BannedTradeRequestGrid;